import { TranslateService } from 'Public_old/src/app/Common/Services/translate.service';
import {
	Component,
	Output,
	Input,
	EventEmitter,
	ElementRef,
	Directive,
	Provider,
	forwardRef,
	Injector,
	ViewChild,
	EnvironmentInjector,
	Self,
	inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl, NgControl } from '@angular/forms';
import { GlobalValidator } from '../Classes/globalValidator';
import { parse, format, isValidNumber } from 'libphonenumber-js';

@Component({
	standalone: false,
	selector: 'visiba-tel',
	template: `
		<div class="wallInput wallStyling" [class.hasIcon]="icon != null">
			<visiba-svg *ngIf="icon != null" class="iconSvg" [color]="iconColor" [a]="icon"></visiba-svg>
			<label [class.value]="number != null && number != ''" [class.svg]="icon != null">{{ localPlaceholder }}</label>
			<input
				[tabindex]="tabInd"
				type="tel"
				[readonly]="readonly"
				[(ngModel)]="number"
				[placeholder]="localPlaceholder"
				(ngModelChange)="validateAndEmitValue()"
				(focus)="suggestnumberCode()"
				(blur)="clearnumberCode()"
				(click)="suggestnumberCode()"
			/>
			<div class="countrySelection">
				<visiba-svg (click)="toggleCountryList()" [color]="iconColor" a="Globe"></visiba-svg>
				<visiba-svg (click)="toggleCountryList()" [color]="iconColor" a="ArrowDown"></visiba-svg>
			</div>
			<div class="select" [class.open]="showList" #ulWrap>
				<ul>
					<ng-template ngFor let-c [ngForOf]="countriesFiltered">
						<li
							[class.selected]="c.countryCode === selectedCountry?.countryCode"
							[class.targeted]="c.countryCode === targetedCountry?.countryCode"
							(click)="countryChange(c)"
							(mouseover)="targetedCountry = c"
						>
							<span [innerHtml]="c.searchName"></span> <span class="code">+ {{ c.numberCode }}</span>
						</li>
					</ng-template>
				</ul>
			</div>
			<span class="error" [class.value]="number != null && number != ''">{{ currentError }}</span>
		</div>
	`,
	host: {
		'[class.readonly]': 'readonly',
	},
})
export class VisibaTelComponent implements ControlValueAccessor {
	@Input() tabInd = 0;
	@Input() icon: string = null;
	@Input() iconColor: string = null;
	@Input() country: string = µ.LicenceHolder.CountryCode;
	@Input() placeholder = '';
	@Input() staticplaceholder = '';
	@Input() readonly: boolean;
	@Input() errorMessages: { [name: string]: string } | string = 'default';
	@Input('modeValue') number: string = null;

	@ViewChild('ulWrap', { static: false }) ulWrap: ElementRef;

	@Output() onChange = new EventEmitter<string>();

	currentError: string = null;
	selectedCountry: any = null;
	targetedCountry: any = null;
	showList = false;
	localPlaceholder: string = null;

	countries: any[] = [
		//{ countryCode: 'AC', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'AD', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'AX', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'BL', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'BQ', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'CW', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'ME', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'MF', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'MM', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'PS', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'RS', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'SX', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'TA', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'TC', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'VA', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'VG', 'DescriptiveName': null, 'delete': true },
		//{ countryCode: 'VI', 'DescriptiveName': null, 'delete': true },
		{ countryCode: 'AF', name: 'Afghanistan', nativeName: 'افغانستان', numberCode: '93' },
		{ countryCode: 'AL', name: 'Albania', nativeName: 'Shqipëria', numberCode: '355' },
		{ countryCode: 'DZ', name: 'Algeria', nativeName: 'الجزائر', numberCode: '213' },
		{ countryCode: 'AS', name: 'American Samoa', nativeName: 'American Samoa', numberCode: '1684' },
		{ countryCode: 'AO', name: 'Angola', nativeName: 'Angola', numberCode: '244' },
		{ countryCode: 'AI', name: 'Anguilla', nativeName: 'Anguilla', numberCode: '1264' },
		{ countryCode: 'AG', name: 'Antigua and Barbuda', nativeName: 'Antigua and Barbuda', numberCode: '1268' },
		{ countryCode: 'AR', name: 'Argentina', nativeName: 'Argentina', numberCode: '54' },
		{ countryCode: 'AM', name: 'Armenia', nativeName: 'Հայաստան', numberCode: '374' },
		{ countryCode: 'AW', name: 'Aruba', nativeName: 'Aruba', numberCode: '297' },
		{ countryCode: 'AU', name: 'Australia', nativeName: 'Australia', numberCode: '61' },
		{ countryCode: 'AT', name: 'Austria', nativeName: 'Österreich', numberCode: '43' },
		{ countryCode: 'AZ', name: 'Azerbaijan', nativeName: 'Azərbaycan', numberCode: '994' },
		{ countryCode: 'BH', name: 'Bahrain', nativeName: '‏البحرين', numberCode: '973' },
		{ countryCode: 'BD', name: 'Bangladesh', nativeName: 'বাংলাদেশ', numberCode: '880' },
		{ countryCode: 'BB', name: 'Barbados', nativeName: 'Barbados', numberCode: '1246' },
		{ countryCode: 'BY', name: 'Belarus', nativeName: 'Белару́сь', numberCode: '375' },
		{ countryCode: 'BE', name: 'Belgium', nativeName: 'België', numberCode: '32' },
		{ countryCode: 'BZ', name: 'Belize', nativeName: 'Belize', numberCode: '501' },
		{ countryCode: 'BJ', name: 'Benin', nativeName: 'Bénin', numberCode: '229' },
		{ countryCode: 'BM', name: 'Bermuda', nativeName: 'Bermuda', numberCode: '1441' },
		{ countryCode: 'BT', name: 'Bhutan', nativeName: 'ʼbrug-yul', numberCode: '975' },
		{ countryCode: 'BO', name: 'Bolivia', nativeName: 'Bolivia', numberCode: '591' },
		{ countryCode: 'BA', name: 'Bosnia and Herzegovina', nativeName: 'Bosna i Hercegovina', numberCode: '387' },
		{ countryCode: 'BW', name: 'Botswana', nativeName: 'Botswana', numberCode: '267' },
		{ countryCode: 'BR', name: 'Brazil', nativeName: 'Brasil', numberCode: '55' },
		{ countryCode: 'IO', name: 'British Indian Ocean Territory', nativeName: 'British Indian Ocean Territory', numberCode: '246' },
		{ countryCode: 'BN', name: 'Brunei', nativeName: 'Negara Brunei Darussalam', numberCode: '673' },
		{ countryCode: 'BG', name: 'Bulgaria', nativeName: 'България', numberCode: '359' },
		{ countryCode: 'BF', name: 'Burkina Faso', nativeName: 'Burkina Faso', numberCode: '226' },
		{ countryCode: 'BI', name: 'Burundi', nativeName: 'Burundi', numberCode: '257' },
		{ countryCode: 'KH', name: 'Cambodia', nativeName: 'Kâmpŭchéa', numberCode: '855' },
		{ countryCode: 'CM', name: 'Cameroon', nativeName: 'Cameroon', numberCode: '237' },
		{ countryCode: 'CA', name: 'Canada', nativeName: 'Canada', numberCode: '1' },
		{ countryCode: 'CV', name: 'Cape Verde', nativeName: 'Cabo Verde', numberCode: '238' },
		{ countryCode: 'KY', name: 'Cayman Islands', nativeName: 'Cayman Islands', numberCode: '1345' },
		{ countryCode: 'CF', name: 'Central African Republic', nativeName: 'Ködörösêse tî Bêafrîka', numberCode: '236' },
		{ countryCode: 'TD', name: 'Chad', nativeName: 'Tchad', numberCode: '235' },
		{ countryCode: 'CL', name: 'Chile', nativeName: 'Chile', numberCode: '56' },
		{ countryCode: 'CN', name: 'China', nativeName: '中国', numberCode: '86' },
		{ countryCode: 'CX', name: 'Christmas Island', nativeName: 'Christmas Island', numberCode: '61' },
		{ countryCode: 'CC', name: 'Cocos (Keeling) Islands', nativeName: 'Cocos (Keeling) Islands', numberCode: '61' },
		{ countryCode: 'CO', name: 'Colombia', nativeName: 'Colombia', numberCode: '57' },
		{ countryCode: 'KM', name: 'Comoros', nativeName: 'Komori', numberCode: '269' },
		{ countryCode: 'CK', name: 'Cook Islands', nativeName: 'Cook Islands', numberCode: '682' },
		{ countryCode: 'CR', name: 'Costa Rica', nativeName: 'Costa Rica', numberCode: '506' },
		{ countryCode: 'HR', name: 'Croatia', nativeName: 'Hrvatska', numberCode: '385' },
		{ countryCode: 'CU', name: 'Cuba', nativeName: 'Cuba', numberCode: '53' },
		{ countryCode: 'CY', name: 'Cyprus', nativeName: 'Κύπρος', numberCode: '357' },
		{ countryCode: 'CZ', name: 'Czech Republic', nativeName: 'Česká republika', numberCode: '420' },
		{
			countryCode: 'CD',
			name: 'Democratic Republic of the Congo',
			nativeName: 'République démocratique du Congo',
			numberCode: '243',
		},
		{ countryCode: 'DK', name: 'Denmark', nativeName: 'Danmark', numberCode: '45' },
		{ countryCode: 'DJ', name: 'Djibouti', nativeName: 'Djibouti', numberCode: '253' },
		{ countryCode: 'DM', name: 'Dominica', nativeName: 'Dominica', numberCode: '1767' },
		{ countryCode: 'DO', name: 'Dominican Republic', nativeName: 'República Dominicana', numberCode: '1809' },
		{ countryCode: 'TL', name: 'East Timor', nativeName: 'Timor- Leste', numberCode: '670' },
		{ countryCode: 'EC', name: 'Ecuador', nativeName: 'Ecuador', numberCode: '593' },
		{ countryCode: 'EG', name: 'Egypt', nativeName: 'مصر‎', numberCode: '20' },
		{ countryCode: 'SV', name: 'El Salvador', nativeName: 'El Salvador', numberCode: '503' },
		{ countryCode: 'GQ', name: 'Equatorial Guinea', nativeName: 'Guinea Ecuatorial', numberCode: '240' },
		{ countryCode: 'ER', name: 'Eritrea', nativeName: 'ኤርትራ', numberCode: '291' },
		{ countryCode: 'EE', name: 'Estonia', nativeName: 'Eesti', numberCode: '372' },
		{ countryCode: 'ET', name: 'Ethiopia', nativeName: 'ኢትዮጵያ', numberCode: '251' },
		{ countryCode: 'FK', name: 'Falkland Islands', nativeName: 'Falkland Islands', numberCode: '500' },
		{ countryCode: 'FO', name: 'Faroe Islands', nativeName: 'Føroyar', numberCode: '298' },
		{ countryCode: 'FM', name: 'Federated States of Micronesia', nativeName: 'Micronesia', numberCode: '691' },
		{ countryCode: 'FJ', name: 'Fiji', nativeName: 'Fiji', numberCode: '679' },
		{ countryCode: 'FI', name: 'Finland', nativeName: 'Suomi', numberCode: '358' },
		{ countryCode: 'FR', name: 'France', nativeName: 'France', numberCode: '33' },
		{ countryCode: 'GF', name: 'French Guiana', nativeName: 'Guyane française', numberCode: '594' },
		{ countryCode: 'PF', name: 'French Polynesia', nativeName: 'Polynésie française', numberCode: '689' },
		{ countryCode: 'GA', name: 'Gabon', nativeName: 'Gabon', numberCode: '241' },
		{ countryCode: 'GE', name: 'Georgia', nativeName: 'საქართველო', numberCode: '995' },
		{ countryCode: 'DE', name: 'Germany', nativeName: 'Deutschland', numberCode: '49' },
		{ countryCode: 'GH', name: 'Ghana', nativeName: 'Ghana', numberCode: '233' },
		{ countryCode: 'GI', name: 'Gibraltar', nativeName: 'Gibraltar', numberCode: '350' },
		{ countryCode: 'GR', name: 'Greece', nativeName: 'Ελλάδα', numberCode: '30' },
		{ countryCode: 'GL', name: 'Greenland', nativeName: 'Kalaallit Nunaat', numberCode: '299' },
		{ countryCode: 'GD', name: 'Grenada', nativeName: 'Grenada', numberCode: '1473' },
		{ countryCode: 'GP', name: 'Guadeloupe', nativeName: 'Guadeloupe', numberCode: '590' },
		{ countryCode: 'GU', name: 'Guam', nativeName: 'Guam', numberCode: '1671' },
		{ countryCode: 'GT', name: 'Guatemala', nativeName: 'Guatemala', numberCode: '502' },
		{ countryCode: 'GG', name: 'Guernsey', nativeName: 'Guernsey', numberCode: '44' },
		{ countryCode: 'GN', name: 'Guinea', nativeName: 'Guinée', numberCode: '224' },
		{ countryCode: 'GW', name: 'Guinea- Bissau', nativeName: 'Guiné- Bissau', numberCode: '245' },
		{ countryCode: 'GY', name: 'Guyana', nativeName: 'Guyana', numberCode: '592' },
		{ countryCode: 'HT', name: 'Haiti', nativeName: 'Haïti', numberCode: '509' },
		{ countryCode: 'HN', name: 'Honduras', nativeName: 'Honduras', numberCode: '504' },
		{ countryCode: 'HK', name: 'Hong Kong', nativeName: '香港', numberCode: '852' },
		{ countryCode: 'HU', name: 'Hungary', nativeName: 'Magyarország', numberCode: '36' },
		{ countryCode: 'IS', name: 'Iceland', nativeName: 'Ísland', numberCode: '354' },
		{ countryCode: 'IN', name: 'India', nativeName: 'भारत', numberCode: '91' },
		{ countryCode: 'ID', name: 'Indonesia', nativeName: 'Indonesia', numberCode: '62' },
		{ countryCode: 'IR', name: 'Iran', nativeName: 'Irān', numberCode: '98' },
		{ countryCode: 'IQ', name: 'Iraq', nativeName: 'العراق', numberCode: '964' },
		{ countryCode: 'IE', name: 'Ireland', nativeName: 'Éire', numberCode: '353' },
		{ countryCode: 'IM', name: 'Isle of Man', nativeName: 'Isle of Man', numberCode: '44' },
		{ countryCode: 'IL', name: 'Israel', nativeName: 'יִשְׂרָאֵל', numberCode: '972' },
		{ countryCode: 'IT', name: 'Italy', nativeName: 'Italia', numberCode: '39' },
		{ countryCode: 'CI', name: 'Ivory Coast', nativeName: "Côte d'Ivoire", numberCode: '225' },
		{ countryCode: 'JM', name: 'Jamaica', nativeName: 'Jamaica', numberCode: '1876' },
		{ countryCode: 'JP', name: 'Japan', nativeName: '日本', numberCode: '81' },
		{ countryCode: 'JE', name: 'Jersey', nativeName: 'Jersey', numberCode: '44' },
		{ countryCode: 'JO', name: 'Jordan', nativeName: 'الأردن', numberCode: '962' },
		{ countryCode: 'KZ', name: 'Kazakhstan', nativeName: 'Қазақстан', numberCode: '76' },
		{ countryCode: 'KE', name: 'Kenya', nativeName: 'Kenya', numberCode: '254' },
		{ countryCode: 'KI', name: 'Kiribati', nativeName: 'Kiribati', numberCode: '686' },
		{ countryCode: 'KW', name: 'Kuwait', nativeName: 'الكويت', numberCode: '965' },
		{ countryCode: 'KG', name: 'Kyrgyzstan', nativeName: 'Кыргызстан', numberCode: '996' },
		{ countryCode: 'LA', name: 'Laos', nativeName: 'ສປປລາວ', numberCode: '856' },
		{ countryCode: 'LV', name: 'Latvia', nativeName: 'Latvija', numberCode: '371' },
		{ countryCode: 'LB', name: 'Lebanon', nativeName: 'لبنان', numberCode: '961' },
		{ countryCode: 'LS', name: 'Lesotho', nativeName: 'Lesotho', numberCode: '266' },
		{ countryCode: 'LR', name: 'Liberia', nativeName: 'Liberia', numberCode: '231' },
		{ countryCode: 'LY', name: 'Libya', nativeName: '‏ليبيا', numberCode: '218' },
		{ countryCode: 'LI', name: 'Liechtenstein', nativeName: 'Liechtenstein', numberCode: '423' },
		{ countryCode: 'LT', name: 'Lithuania', nativeName: 'Lietuva', numberCode: '370' },
		{ countryCode: 'LU', name: 'Luxembourg', nativeName: 'Luxembourg', numberCode: '352' },
		{ countryCode: 'MO', name: 'Macau', nativeName: '澳門', numberCode: '853' },
		{ countryCode: 'MG', name: 'Madagascar', nativeName: 'Madagasikara', numberCode: '261' },
		{ countryCode: 'MW', name: 'Malawi', nativeName: 'Malawi', numberCode: '265' },
		{ countryCode: 'MY', name: 'Malaysia', nativeName: 'Malaysia', numberCode: '60' },
		{ countryCode: 'MV', name: 'Maldives', nativeName: 'Maldives', numberCode: '960' },
		{ countryCode: 'ML', name: 'Mali', nativeName: 'Mali', numberCode: '223' },
		{ countryCode: 'MT', name: 'Malta', nativeName: 'Malta', numberCode: '356' },
		{ countryCode: 'MH', name: 'Marshall Islands', nativeName: 'M̧ajeļ', numberCode: '692' },
		{ countryCode: 'MQ', name: 'Martinique', nativeName: 'Martinique', numberCode: '596' },
		{ countryCode: 'MR', name: 'Mauritania', nativeName: 'موريتانيا', numberCode: '222' },
		{ countryCode: 'MU', name: 'Mauritius', nativeName: 'Maurice', numberCode: '230' },
		{ countryCode: 'YT', name: 'Mayotte', nativeName: 'Mayotte', numberCode: '262' },
		{ countryCode: 'MX', name: 'Mexico', nativeName: 'México', numberCode: '52' },
		{ countryCode: 'MD', name: 'Moldova', nativeName: 'Moldova', numberCode: '373' },
		{ countryCode: 'MC', name: 'Monaco', nativeName: 'Monaco', numberCode: '377' },
		{ countryCode: 'MN', name: 'Mongolia', nativeName: 'Монгол улс', numberCode: '976' },
		{ countryCode: 'MS', name: 'Montserrat', nativeName: 'Montserrat', numberCode: '1664' },
		{ countryCode: 'MA', name: 'Morocco', nativeName: 'المغرب', numberCode: '212' },
		{ countryCode: 'MZ', name: 'Mozambique', nativeName: 'Moçambique', numberCode: '258' },
		{ countryCode: 'NA', name: 'Namibia', nativeName: 'Namibia', numberCode: '264' },
		{ countryCode: 'NR', name: 'Nauru', nativeName: 'Nauru', numberCode: '674' },
		{ countryCode: 'NP', name: 'Nepal', nativeName: 'नेपाल', numberCode: '977' },
		{ countryCode: 'NL', name: 'Netherlands', nativeName: 'Nederland', numberCode: '31' },
		{ countryCode: 'NC', name: 'New Caledonia', nativeName: 'Nouvelle-Calédonie', numberCode: '687' },
		{ countryCode: 'NZ', name: 'New Zealand', nativeName: 'New Zealand', numberCode: '64' },
		{ countryCode: 'NI', name: 'Nicaragua', nativeName: 'Nicaragua', numberCode: '505' },
		{ countryCode: 'NE', name: 'Niger', nativeName: 'Niger', numberCode: '227' },
		{ countryCode: 'NG', name: 'Nigeria', nativeName: 'Nigeria', numberCode: '234' },
		{ countryCode: 'NU', name: 'Niue', nativeName: 'Niuē', numberCode: '683' },
		{ countryCode: 'NF', name: 'Norfolk Island', nativeName: 'Norfolk Island', numberCode: '672' },
		{ countryCode: 'KP', name: 'North Korea', nativeName: '북한', numberCode: '850' },
		{ countryCode: 'MP', name: 'Northern Mariana Islands', nativeName: 'Northern Mariana Islands', numberCode: '1670' },
		{ countryCode: 'NO', name: 'Norway', nativeName: 'Norge', numberCode: '47' },
		{ countryCode: 'OM', name: 'Oman', nativeName: 'عمان', numberCode: '968' },
		{ countryCode: 'PK', name: 'Pakistan', nativeName: 'Pakistan', numberCode: '92' },
		{ countryCode: 'PW', name: 'Palau', nativeName: 'Palau', numberCode: '680' },
		{ countryCode: 'PA', name: 'Panama', nativeName: 'Panamá', numberCode: '507' },
		{ countryCode: 'PG', name: 'Papua New Guinea', nativeName: 'Papua Niugini', numberCode: '675' },
		{ countryCode: 'PY', name: 'Paraguay', nativeName: 'Paraguay', numberCode: '595' },
		{ countryCode: 'PE', name: 'Peru', nativeName: 'Perú', numberCode: '51' },
		{ countryCode: 'PH', name: 'Philippines', nativeName: 'Pilipinas', numberCode: '63' },
		{ countryCode: 'PL', name: 'Poland', nativeName: 'Polska', numberCode: '48' },
		{ countryCode: 'PT', name: 'Portugal', nativeName: 'Portugal', numberCode: '351' },
		{ countryCode: 'PR', name: 'Puerto Rico', nativeName: 'Puerto Rico', numberCode: '1787' },
		{ countryCode: 'QA', name: 'Qatar', nativeName: 'قطر', numberCode: '974' },
		{ countryCode: 'MK', name: 'Republic of Macedonia', nativeName: 'Македонија', numberCode: '389' },
		{ countryCode: 'CG', name: 'Republic of the Congo', nativeName: 'République du Congo', numberCode: '242' },
		{ countryCode: 'RO', name: 'Romania', nativeName: 'România', numberCode: '40' },
		{ countryCode: 'RU', name: 'Russia', nativeName: 'Россия', numberCode: '7' },
		{ countryCode: 'RW', name: 'Rwanda', nativeName: 'Rwanda', numberCode: '250' },
		{ countryCode: 'RE', name: 'Réunion', nativeName: 'La Réunion', numberCode: '262' },
		{ countryCode: 'SH', name: 'Saint Helena', nativeName: 'Saint Helena', numberCode: '290' },
		{ countryCode: 'KN', name: 'Saint Kitts and Nevis', nativeName: 'Saint Kitts and Nevis', numberCode: '1869' },
		{ countryCode: 'LC', name: 'Saint Lucia', nativeName: 'Saint Lucia', numberCode: '1758' },
		{ countryCode: 'PM', name: 'Saint Pierre and Miquelon', nativeName: 'Saint- Pierre - et - Miquelon', numberCode: '508' },
		{
			countryCode: 'VC',
			name: 'Saint Vincent and the Grenadines',
			nativeName: 'Saint Vincent and the Grenadines',
			numberCode: '1784',
		},
		{ countryCode: 'WS', name: 'Samoa', nativeName: 'Samoa', numberCode: '685' },
		{ countryCode: 'SM', name: 'San Marino', nativeName: 'San Marino', numberCode: '378' },
		{ countryCode: 'SA', name: 'Saudi Arabia', nativeName: 'العربية السعودية', numberCode: '966' },
		{ countryCode: 'SN', name: 'Senegal', nativeName: 'Sénégal', numberCode: '221' },
		{ countryCode: 'SC', name: 'Seychelles', nativeName: 'Seychelles', numberCode: '248' },
		{ countryCode: 'SL', name: 'Sierra Leone', nativeName: 'Sierra Leone', numberCode: '232' },
		{ countryCode: 'SG', name: 'Singapore', nativeName: 'Singapore', numberCode: '65' },
		{ countryCode: 'SK', name: 'Slovakia', nativeName: 'Slovensko', numberCode: '421' },
		{ countryCode: 'SI', name: 'Slovenia', nativeName: 'Slovenija', numberCode: '386' },
		{ countryCode: 'SB', name: 'Solomon Islands', nativeName: 'Solomon Islands', numberCode: '677' },
		{ countryCode: 'SO', name: 'Somalia', nativeName: 'Soomaaliya', numberCode: '252' },
		{ countryCode: 'ZA', name: 'South Africa', nativeName: 'South Africa', numberCode: '27' },
		{ countryCode: 'KR', name: 'South Korea', nativeName: '대한민국', numberCode: '82' },
		{ countryCode: 'SS', name: 'South Sudan', nativeName: 'South Sudan', numberCode: '211' },
		{ countryCode: 'ES', name: 'Spain', nativeName: 'España', numberCode: '34' },
		{ countryCode: 'LK', name: 'Sri Lanka', nativeName: 'śrī laṃkāva', numberCode: '94' },
		{ countryCode: 'SD', name: 'Sudan', nativeName: 'السودان', numberCode: '249' },
		{ countryCode: 'SR', name: 'Suriname', nativeName: 'Suriname', numberCode: '597' },
		{ countryCode: 'SJ', name: 'Svalbard and Jan Mayen', nativeName: 'Svalbard og Jan Mayen', numberCode: '4779' },
		{ countryCode: 'SZ', name: 'Swaziland', nativeName: 'Swaziland', numberCode: '268' },
		{ countryCode: 'SE', name: 'Sweden', nativeName: 'Sverige', numberCode: '46' },
		{ countryCode: 'CH', name: 'Switzerland', nativeName: 'Schweiz', numberCode: '41' },
		{ countryCode: 'SY', name: 'Syria', nativeName: 'سوريا', numberCode: '963' },
		{ countryCode: 'ST', name: 'São Tomé and Príncipe', nativeName: 'São Tomé e Príncipe', numberCode: '239' },
		{ countryCode: 'TW', name: 'Taiwan', nativeName: '臺灣', numberCode: '886' },
		{ countryCode: 'TJ', name: 'Tajikistan', nativeName: 'Тоҷикистон', numberCode: '992' },
		{ countryCode: 'TZ', name: 'Tanzania', nativeName: 'Tanzania', numberCode: '255' },
		{ countryCode: 'TH', name: 'Thailand', nativeName: 'ประเทศไทย', numberCode: '66' },
		{ countryCode: 'BS', name: 'The Bahamas', nativeName: 'Bahamas', numberCode: '1242' },
		{ countryCode: 'GM', name: 'The Gambia', nativeName: 'Gambia', numberCode: '220' },
		{ countryCode: 'TG', name: 'Togo', nativeName: 'Togo', numberCode: '228' },
		{ countryCode: 'TK', name: 'Tokelau', nativeName: 'Tokelau', numberCode: '690' },
		{ countryCode: 'TO', name: 'Tonga', nativeName: 'Tonga', numberCode: '676' },
		{ countryCode: 'TT', name: 'Trinidad and Tobago', nativeName: 'Trinidad and Tobago', numberCode: '1868' },
		{ countryCode: 'TN', name: 'Tunisia', nativeName: 'تونس', numberCode: '216' },
		{ countryCode: 'TR', name: 'Turkey', nativeName: 'Türkiye', numberCode: '90' },
		{ countryCode: 'TM', name: 'Turkmenistan', nativeName: 'Türkmenistan', numberCode: '993' },
		{ countryCode: 'TV', name: 'Tuvalu', nativeName: 'Tuvalu', numberCode: '688' },
		{ countryCode: 'UG', name: 'Uganda', nativeName: 'Uganda', numberCode: '256' },
		{ countryCode: 'UA', name: 'Ukraine', nativeName: 'Україна', numberCode: '380' },
		{ countryCode: 'AE', name: 'United Arab Emirates', nativeName: 'دولة الإمارات العربية المتحدة', numberCode: '971' },
		{ countryCode: 'GB', name: 'United Kingdom', nativeName: 'United Kingdom', numberCode: '44' },
		{ countryCode: 'US', name: 'United States', nativeName: 'United States', numberCode: '1' },
		{ countryCode: 'UY', name: 'Uruguay', nativeName: 'Uruguay', numberCode: '598' },
		{ countryCode: 'UZ', name: 'Uzbekistan', nativeName: 'O‘zbekiston', numberCode: '998' },
		{ countryCode: 'VU', name: 'Vanuatu', nativeName: 'Vanuatu', numberCode: '678' },
		{ countryCode: 'VE', name: 'Venezuela', nativeName: 'Venezuela', numberCode: '58' },
		{ countryCode: 'VN', name: 'Vietnam', nativeName: 'Việt Nam', numberCode: '84' },
		{ countryCode: 'WF', name: 'Wallis and Futuna', nativeName: 'Wallis et Futuna', numberCode: '681' },
		{ countryCode: 'EH', name: 'Western Sahara', nativeName: 'الصحراء الغربية', numberCode: '212' },
		{ countryCode: 'YE', name: 'Yemen', nativeName: 'اليَمَن', numberCode: '967' },
		{ countryCode: 'ZM', name: 'Zambia', nativeName: 'Zambia', numberCode: '260' },
		{ countryCode: 'ZW', name: 'Zimbabwe', nativeName: 'Zimbabwe', numberCode: '263' },
	];

	countriesFiltered = [];
	countryListSearch = '';

	constructor(
		private _elem: ElementRef,
		@Self() public controlDir: NgControl,
		private translateService: TranslateService,
	) {
		controlDir.valueAccessor = this;
	}

	writeValue(value: any) {
		this.number = value;
		this.validateAndEmitValue(false);
	}

	//Call to push value
	propagateChange = (_: any) => {};

	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	registerOnTouch() {}
	registerOnTouched() {}

	ngOnInit() {
		const countrySearch = this.countries.filter((item) => {
			return item.countryCode === this.country;
		});

		if (countrySearch.length > 0) this.countryChange(countrySearch[0], false);
		else {
			const defualtCountrySearch = this.countries.filter((item) => {
				return item.countryCode === µ.LicenceHolder.CountryCode;
			});
			if (defualtCountrySearch.length > 0) {
				this.countryChange(defualtCountrySearch[0], false);
			} else {
				this.countryChange(this.countries[0], false);
			}
		}
		this.localPlaceholder =
			(this.placeholder === '' ? '' : this.translateService.get(this.placeholder)) + (this._elem.nativeElement.required ? ' *' : '');
	}

	toggleCountryList() {
		if (this.showList) this.hideCountryList();
		else this.showCountryList();
	}

	showCountryList() {
		if (this.readonly) return;

		this.showList = true;
		this.countryListSearch = '';
		this.filterCountries();

		const doc = document.getElementsByTagName('html')[0];
		window.setTimeout(() => {
			doc.addEventListener('keyup', this.countrySelectKeyEvent, false);
			doc.addEventListener('keydown', this.countrySelectKeyEvent, false);
			doc.addEventListener('click', this.closeCountrySelectEventFunction, false);
		}, 10);
	}

	hideCountryList() {
		this.showList = false;

		const doc = document.getElementsByTagName('html')[0];
		doc.removeEventListener('keyup', this.countrySelectKeyEvent, false);
		doc.removeEventListener('keydown', this.countrySelectKeyEvent, false);
		doc.removeEventListener('click', this.closeCountrySelectEventFunction, false);
	}

	closeCountrySelectEventFunction = (event) => {
		if (
			event.target &&
			this._elem.nativeElement.querySelector('.select') !== event.target &&
			!this._elem.nativeElement.querySelector('.select').contains(event.target)
		) {
			this.hideCountryList();
		}
	};
	countrySelectKeyEvent = (event: KeyboardEvent) => {
		event.stopPropagation();
		event.preventDefault();

		if (event.type === 'keydown') return;
		switch (event.key) {
			case 'Enter':
				if (this.targetedCountry !== null) this.countryChange(this.targetedCountry);
				break;
			case 'ArrowDown':
				this.arrowMove(1);
				break;
			case 'ArrowUp':
				this.arrowMove(-1);
				break;
			case 'Escape':
				this.hideCountryList();
				break;
			case 'Backspace':
				if (this.countryListSearch.length > 0) {
					this.countryListSearch = this.countryListSearch.substring(0, this.countryListSearch.length - 1);
					this.filterCountries();
				}
				break;
			default:
				if (event.key.length === 1 && /[a-z ()]/i.test(event.key)) {
					// Saknas arabiska stöd
					this.countryListSearch += event.key.toLowerCase();
					this.filterCountries();
				}
		}
	};

	filterCountries() {
		this.countriesFiltered = this.countries.filter((c) => {
			const result =
				c.name.toLowerCase().indexOf(this.countryListSearch) > -1 || c.nativeName.toLowerCase().indexOf(this.countryListSearch) > -1;

			if (result) {
				c.searchName = c.name;
				if (c.nativeName !== c.name) c.searchName += ` (${c.nativeName})`;

				const regex = new RegExp('(' + this.countryListSearch + ')', 'i');
				c.searchName = c.searchName.replace(regex, '<span>$1</span>');
			}

			return result;
		});
	}

	arrowMove(direction: number) {
		let pos = -1;
		if (this.targetedCountry !== null)
			pos = this.countriesFiltered.map((o) => o.countryCode).indexOf(this.targetedCountry.countryCode);

		const newPos = pos + direction;

		if (newPos >= 0 && newPos < this.countriesFiltered.length) this.targetedCountry = this.countriesFiltered[newPos];

		if (!this.showList) this.showCountryList();

		const targetElement = this.ulWrap.nativeElement.querySelector('.targeted');
		if (targetElement !== null) this.ulWrap.nativeElement.scrollTop = targetElement.offsetTop - targetElement.clientHeight;
	}

	validateAndEmitValue(emit = true) {
		const startNumber = this.number;
		if (this.number === '') this.number = null;
		if (this.number !== null) {
			const calculatedDialcode = this.getDialCode(this.number).replace('+', '');
			if (calculatedDialcode !== '' && calculatedDialcode !== this.selectedCountry.numberCode) {
				const matches = this.countries.filter((item) => {
					return item.numberCode === calculatedDialcode;
				});
				if (matches.length > 0) this.countryChange(matches[0], emit);

				return; // Will come back here from countryChange anyways
			}
			//Use phone lib number to format number if possible
			if (this.number.length < 6) return; // google-lib throws error if trying to validate number shortar than countryCode + 2
			let num;
			try {
				num = parse(this.number, this.selectedCountry.countryCode);
				if (isValidNumber(num)) {
					this.number = format(num, 'INTERNATIONAL');
				}
			} catch (numberParseException) {}
		}

		window.setTimeout(() => {
			this.handleErrors();
		});

		if (!emit && this.number === startNumber) return;

		window.setTimeout(() => {
			// Timeout needed for emit to happen when writeValue needs formatting
			this.propagateChange((this.number || '').replace(/ /g, ''));
			if (!emit) {
				(this.controlDir.control as UntypedFormControl).reset(this.number);
			}
		});

		if (typeof this.onChange !== 'undefined') {
			window.setTimeout(() => {
				this.onChange.emit(this.number);
			}, 10);
		}
	}

	// Gui events
	suggestnumberCode() {
		if (this.readonly) return;

		if (typeof this.number === 'undefined' || this.number === null || this.number === '')
			this.number = '+' + this.selectedCountry.numberCode + ' ';
	}

	clearnumberCode() {
		if (this.number === '+' + this.selectedCountry.numberCode + ' ' || this.number === '+' + this.selectedCountry.numberCode) {
			this.number = null;
			this.validateAndEmitValue();
		}
	}

	countryChange(country: any, emit = true) {
		this.selectedCountry = country;

		if (this.getDialCode(this.number) !== '')
			this.number = this.number.replace(this.getDialCode(this.number), '+' + country.numberCode);

		this.hideCountryList();
		this.validateAndEmitValue(emit);
	}

	getDialCode(number): string {
		let dialCode = '';

		if (typeof number !== 'undefined' && number !== null) {
			// only interested in international numbers (starting with a plus)
			if (number.charAt(0) == '+') {
				dialCode = '+';
				let numericChars = '';
				// iterate over chars
				for (let i = 0; i < number.length; i++) {
					const c = number.charAt(i);
					// if char is number
					if (!isNaN(parseFloat(c)) && isFinite(c)) {
						numericChars += c;
						// if current numericChars make a valid dial code
						if (
							this.countries.filter((item) => {
								return item.numberCode === numericChars;
							}).length > 0
						) {
							// store the actual raw string (useful for matching later)
							dialCode = number.substr(0, i + 1);
						}
						// longest dial code is 4 chars
						if (numericChars.length == 4) {
							break;
						}
					}
				}
			}
		}

		return dialCode;
	}

	handleErrors() {
		this.currentError = GlobalValidator.validateFormControl(
			this.translateService,
			this.controlDir.control as UntypedFormControl,
			this.errorMessages,
		);
	}
}
